// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#newsBackDrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  overflow: hidden;
  z-index: 99998;
}

#header {
  padding: 20px;
  border-radius: 7px 7px 0 0;
  background-color: white;
}

#footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: white;
  height: 75px;
  border-radius: 0 0 7px 7px;
  padding: 30px 20px 20px 20px;
}

#newsFrame {
  width: 50%;
  height: 75%;
  position: fixed;
  border: 1px solid #9A9A9A;
  background-color: #ddd;
  padding: 0;
  z-index: 99999;
  cursor: default;
  border-radius: 5px;
  top: 25px;
  left: 25%;
}

/**

    box-shadow: 0 2px 2px 1px #DDD;
 */
#innerFrameContainer {
  position: relative;
  height: 100%;
  width: 100%;
}

#innerFrame {
  margin: 20px 20px 60px 20px;
  position: absolute;
  background-color: white;
  border: 1px solid #bbb;
  top: 0;
  right: 0;
  left: 0;
  bottom: 100px;
  padding: 10px;
  overflow-y: scroll;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.visible {
  display: block !important;
  opacity: 1 !important;
}

.invisible {
  display: none !important;
  opacity: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/news/components/news/news.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EAEA,oCAAA;EAEA,gBAAA;EAEA,cAAA;AAFJ;;AAKA;EACI,aAAA;EACA,0BAAA;EACA,uBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,4BAAA;AAFJ;;AAKA;EACI,UAAA;EACA,WAAA;EAEA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;EAEA,eAAA;EAEA,kBAAA;EAEA,SAAA;EACA,SAAA;AANJ;;AAUA;;;EAAA;AAKA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AARJ;;AAWA;EACI,2BAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EAGA,iBAAA;AARJ;;AAWA;EACI,yBAAA;EACA,qBAAA;AARJ;;AAWA;EACI,wBAAA;EACA,qBAAA;AARJ","sourcesContent":["#newsBackDrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    background-color: rgba(0, 0, 0, 0.3);\n\n    overflow: hidden;\n\n    z-index: 99998;\n}\n\n#header {\n    padding: 20px;\n    border-radius: 7px 7px 0 0;\n    background-color: white;\n}\n\n#footer {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    background-color: white;\n    height: 75px;\n    border-radius: 0 0 7px 7px;\n    padding: 30px 20px 20px 20px;\n}\n\n#newsFrame {\n    width: 50%;\n    height: 75%;\n\n    position: fixed;\n    border: 1px solid #9A9A9A;\n    background-color: #ddd;\n    padding: 0;\n    z-index: 99999;\n\n    cursor: default;\n\n    border-radius: 5px;\n\n    top: 25px;\n    left: 25%;\n\n}\n\n/**\n\n    box-shadow: 0 2px 2px 1px #DDD;\n */\n\n#innerFrameContainer {\n    position: relative;\n    height: 100%;\n    width: 100%;\n}\n\n#innerFrame {\n    margin: 20px 20px 60px 20px;\n    position: absolute;\n    background-color: white;\n    border: 1px solid #bbb;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 100px;\n    padding: 10px;\n    overflow-y: scroll;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.visible {\n    display: block !important;\n    opacity: 1 !important;\n}\n\n.invisible {\n    display: none !important;\n    opacity: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
